export const mdiChevronRight = 'M8.59 16.58 13.17 12 8.59 7.41 10 6l6 6-6 6z';